import * as React from "react"

function TitleHowFast(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={308} height={127} viewBox="0 0 308 127" {...props}>
      <title>{"How fast can I get there?"}</title>
      <g fill="none" fillRule="evenodd">
        <text
          fontFamily="Licenz"
          fontSize={34}
          letterSpacing={0.117}
          fill="#FFF"
        >
          <tspan x={69.079} y={49}>
            {"HOW"}
          </tspan>
        </text>
        <text
          fontFamily="Licenz"
          fontSize={34}
          letterSpacing={0.117}
          fill="#FFF"
        >
          <tspan x={40.1} y={99}>
            {"CAN I GET THERE "}
          </tspan>
        </text>
        <text
          fontFamily="HyperwaveTwo, Hyperwave Two"
          fontSize={89}
          fill="#E3E833"
        >
          <tspan x={135} y={63}>
            {"FAst"}
          </tspan>
        </text>
        <text
          fontFamily="HyperwaveTwo, Hyperwave Two"
          fontSize={89}
          fill="#FFF"
        >
          <tspan x={262} y={120}>
            {"?"}
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default TitleHowFast
